import { memo } from 'react';
import { useSidebarProjects } from '@/hooks/useSidebarProjects';
import SidebarProjectListSafe from '@/components/feature/SidebarProjectListSafe';

interface Props {
  active: boolean;
  profileId?: string;
  userType?: string;
  profileLoading?: boolean;
  currentProjectId?: string;
  currentProjectName?: string;
  buildProjectUrl: (projectId: string) => string;
  onProjectClick?: () => void;
  emptyLabel?: string;
}

/** Isolated sidebar project list — state updates here do not re-render layout page content. */
function SidebarProjectsNavSection({
  active,
  profileId,
  userType,
  profileLoading,
  currentProjectId,
  currentProjectName,
  buildProjectUrl,
  onProjectClick,
  emptyLabel,
}: Props) {
  const fallbackProject =
    currentProjectId && currentProjectName
      ? { id: currentProjectId, project_name: currentProjectName }
      : null;

  const { projects, loading, hasResolved, error, retry } = useSidebarProjects(
    profileId,
    userType,
    active,
    { profileLoading, fallbackProject },
  );

  if (!active) return null;

  return (
    <SidebarProjectListSafe
      projects={projects}
      loading={loading}
      hasResolved={hasResolved}
      error={error}
      onRetry={retry}
      currentProjectId={currentProjectId}
      buildProjectUrl={buildProjectUrl}
      onProjectClick={onProjectClick}
      emptyLabel={emptyLabel}
    />
  );
}

export default memo(SidebarProjectsNavSection);
